/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { type Params } from 'react-router-dom';

import {
  getContainerSubplanTier,
  startProductContainerTrial,
} from '@fai/friendli-suite/features/routes/loaders/apis/product/container';

export const startContainerTrial = async ({ params }: { params: Params<'teamId'> }) => {
  const teamId = params.teamId ?? '';
  const plan = await getContainerSubplanTier({ teamId });

  if (plan === 'NONE_OWNER') {
    try {
      await startProductContainerTrial({ teamId });
    } catch (error) {
      // TODO: do something if starting trial plan failed
      console.error(error);
    }
  }

  return null;
};
